<template lang="pug">
  .card(:style="{color: textColor, backgroundColor: bgColor}")
    .card-content
      .field
        label.label(:style="{color: labelColor}") {{ data.negocio }}
        span.tag.is-light(:style="{color: labelColor, backgroundColor: buttonColor}")
          b {{ data.compania }}
        br
        span.tag.is-light(:style="{color: labelColor, backgroundColor: buttonColor}")
          b {{ data.nominacion }} Ton.
      span
        | {{ data.porcentaje }}%
      br
      progress.progress.is-large(:value='data.porcentaje' max='100') {{ data.porcentaje }}%
      span.is-size-7
        | Surt.&nbsp
        b {{ `${data.surtido}`}}
        | &nbspTons.
      br
      span.is-size-7
        | Rest.&nbsp
        b {{ `${data.restante}`}}
        | &nbspTons.
      br
      span.is-size-7
        | Aut. aprox.&nbsp
        b {{ `${parseInt((data.restante / 20))}`}}
</template>

<script>
  export default {
    name: 'CardSubgrupo',
    props: {
      data: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        bgColor: '',
        textColor: '',
        labelColor: '',
        buttonColor: ''
      }
    },
    watch: {
      data() {
        this.getColors()
      }
    },
    methods: {
      getColors() {
        this.bgColor = this.data.color
        this.textColor = this.data.textColor
        this.labelColor = this.data.label
        this.buttonColor = this.data.button
      }
    },
    created () {
      this.getColors()
    },
  }
</script>

<style lang="scss" scoped>
  .card {
    color: white
  }
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/cuartocontrol/componentes/CardSubgrupo.vue